import { Component } from '@angular/core';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { AdminService } from '../../../models/admin/adminService';
import { SimpleDialogComponent, SimpleDialogData } from '../../../../../../../libs/Shared/components/dialogs/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';


export interface MerchantBrand {
  name: string;
  count: number;
}
@Component({
  selector: 'app-merchant-brands',
  templateUrl: './merchant-brands.component.html',
  standalone: false,
})
export class MerchantBrandsComponent {
  hasReadAccess = false;
  hasWriteAccess = false;
  records: MerchantBrand[] = [];
  loading: boolean = false;
  isEditing: boolean = false;

  constructor(
    private accessManager: AccessManager,
    private adminService: AdminService,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_UPDATE_MERCHANT_BRANDS,
        AccessManager.AUTH_SELECT_MERCHANT_BRANDS,
      ])
      .then((access) => {
        this.hasReadAccess = access[AccessManager.AUTH_SELECT_MERCHANT_BRANDS];
        this.hasWriteAccess = access[AccessManager.AUTH_UPDATE_MERCHANT_BRANDS];

        if (this.hasReadAccess) {
          this.reload();
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public create() {
    const dialogRef = this.dialog.open<SimpleDialogComponent, SimpleDialogData, string | null>(
      SimpleDialogComponent,
      {
        data: {
          new: false,
          name: '',
          title: 'Create Brand',
          label: 'Brand Name',
          submitText: 'Create',
          required: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (!!result) {
        this.adminService.createBrand(result.trim()).then(() => {
          this.reload();
        });
      }
    });
  }

  public select(record: MerchantBrand) {
    const dialogRef = this.dialog.open<SimpleDialogComponent, SimpleDialogData, string | null>(
      SimpleDialogComponent,
      {
        data: {
          new: false,
          name: record.name,
          title: 'Rename Brand',
          label: 'Brand Name',
          submitText: 'Update',
          required: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== null && result !== undefined && result !== record.name) {
        this.save(record.name, result);
      }
    });
  }

  public save(oldName: string, newName: string) {
    this.adminService.updateBrand(oldName, newName).then(() => {
      this.reload();
    }).catch(console.error);
  }

  public btnDelete_click(record: MerchantBrand) {
    if (confirm(`Are you sure you want to delete brand ${record.name}?`)) {
      this.adminService
        .deleteBrand(record.name)
        .then(() => {
          this.reload();
        })
        .catch((e) => {
          this.uiErrorHandler.handleError(e);
        });
    }
  }

  async reload() {
    this.loading = true;

    this.adminService
      .getMerchantBrandsUsed()
      .then((items: MerchantBrand[]) => {
        this.records = items;
        this.loading = false;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

}
